/* eslint-disable import/no-unresolved */
import React from 'react';
import OptimizedImage from '../OptimizedImage';

const Description = () => {
  return (
    <div className="container">
      <div className="top-beam">
        <div className="row">
          <div className="col-lg-7">
            <div className="description">
              <div className="subtitle bigger">Our DNA</div>
              <h3>Our inspiration</h3>
              <p>
                When someone brought up Stanislaw Ulam as a name inspiration,
                our brainstorming bickering ceased. The Lviv-born Polish
                scientist and mathematician, who is most known for his work with
                computers inspired all of us. We embrace his legacy in our logo,
                by using a variation of his Prime Spiral, or Ulam Spiral. It is
                a subtle reminder for all of us to create something greater than
                just a program.
              </p>
              <br />
              <h3>In the heart of global IT development</h3>
              <p>
                Even in today&apos;s digital era where the need for human
                interaction is almost extinct, the opportunity to meet project
                members is invaluable. With Ulam Labs, you can feel at home when
                we meet face-to-face in Central Europe, in our offices in
                Wroclaw and Warsaw. As a bonus, you save yourself the potential
                of a week-long jetlag.
              </p>
              <p>
                Poland has been ranked among the Top 5 countries with the most
                skilled programmers. Our headquarters provide us access to over
                100,000 IT professionals to scale with the needs of our clients.
                Choose Ulam Labs as your developers, and choose our
                professionalism, timeliness, and dedication to creating the best
                products possible.
              </p>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="image">
              <OptimizedImage
                src="/about-us/stanislaw_ulam.png"
                alt="Stanislaw Ulam"
                title="Stanislaw Ulam"
              />
              <div className="signature">
                Stanislaw Ulam, 1945, Los Alamos National Laboratory/PAP
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Description;
